export const Permisos = {
  // Seguridad: Usuarios
  USUARIOS_VER: 'seguridad.usuarios.ver',
  USUARIOS_CREAR: 'seguridad.usuarios.crear',
  USUARIOS_EDITAR: 'seguridad.usuarios.editar',
  USUARIOS_ELIMINAR: 'seguridad.usuarios.eliminar',
  // Seguridad: Roles
  ROLES_VER: 'seguridad.roles.ver',
  ROLES_CREAR: 'seguridad.roles.crear',
  ROLES_EDITAR: 'seguridad.roles.editar',
  ROLES_ELIMINAR: 'seguridad.roles.eliminar',
  // Seguridad: Permisos
  PERMISOS_VER: 'seguridad.permisos.ver',
  // Seguridad: Sesiones
  SESIONES_VER: 'seguridad.sesiones.ver',
  SESIONES_REVOCAR: 'seguridad.sesiones.revocar',
  // Seguridad: Organizaciones
  ORGANIZACIONES_VER: 'seguridad.organizaciones.ver',
  ORGANIZACIONES_CREAR: 'seguridad.organizaciones.crear',
  ORGANIZACIONES_EDITAR: 'seguridad.organizaciones.editar',
  // Seguridad: Aplicaciones
  APLICACIONES_VER: 'seguridad.aplicaciones.ver',
  APLICACIONES_CREAR: 'seguridad.aplicaciones.crear',
  APLICACIONES_EDITAR: 'seguridad.aplicaciones.editar',
  // Seguridad: SMTP
  SMTP_VER: 'seguridad.smtp.ver',
  SMTP_CREAR: 'seguridad.smtp.crear',
  SMTP_EDITAR: 'seguridad.smtp.editar',
  SMTP_ELIMINAR: 'seguridad.smtp.eliminar',
  // RECET: Tecnologias
  TECNOLOGIAS_VER: 'recet.tecnologias.ver',
  TECNOLOGIAS_CREAR: 'recet.tecnologias.crear',
  TECNOLOGIAS_EDITAR: 'recet.tecnologias.editar',
  TECNOLOGIAS_ELIMINAR: 'recet.tecnologias.eliminar',
  TECNOLOGIAS_SUBIR: 'recet.tecnologias.subir',
  TECNOLOGIAS_EXPORTAR: 'recet.tecnologias.exportar',
  TECNOLOGIAS_DESCARGAR: 'recet.tecnologias.descargar',
  // RECET: Workflow
  TECNOLOGIAS_SOLICITAR_APROBACION: 'recet.tecnologias.solicitar_aprobacion',
  TECNOLOGIAS_APROBAR: 'recet.tecnologias.aprobar',
  TECNOLOGIAS_RETIRAR_SOLICITUD: 'recet.tecnologias.retirar_solicitud',
  TECNOLOGIAS_SOLICITAR_REAPERTURA: 'recet.tecnologias.solicitar_reapertura',
  TECNOLOGIAS_APROBAR_REAPERTURA: 'recet.tecnologias.aprobar_reapertura',
  // RECET: Comentarios
  COMENTARIOS_VER: 'recet.comentarios.ver',
  COMENTARIOS_CREAR: 'recet.comentarios.crear',
  COMENTARIOS_RESOLVER: 'recet.comentarios.resolver',
  COMENTARIOS_REABRIR: 'recet.comentarios.reabrir',
  COMENTARIOS_ELIMINAR: 'recet.comentarios.eliminar',
  // RECET: Sugerencias
  SUGERENCIAS_VER: 'recet.sugerencias.ver',
  SUGERENCIAS_CREAR: 'recet.sugerencias.crear',
  SUGERENCIAS_ACEPTAR: 'recet.sugerencias.aceptar',
  SUGERENCIAS_RECHAZAR: 'recet.sugerencias.rechazar',
  // RECET: Versiones
  VERSIONES_VER: 'recet.versiones.ver',
  VERSIONES_CREAR: 'recet.versiones.crear',
  VERSIONES_EDITAR: 'recet.versiones.editar',
  VERSIONES_RESTAURAR: 'recet.versiones.restaurar',
  // RECET: Referencias
  REFERENCIAS_VER: 'recet.referencias.ver',
  REFERENCIAS_CREAR: 'recet.referencias.crear',
  REFERENCIAS_EDITAR: 'recet.referencias.editar',
  REFERENCIAS_ELIMINAR: 'recet.referencias.eliminar',
  REFERENCIAS_ASOCIAR: 'recet.referencias.asociar',
  // RECET: Costo-efectividad
  COSTO_EFECTIVIDAD_VER: 'recet.costo_efectividad.ver',
  COSTO_EFECTIVIDAD_EXPORTAR: 'recet.costo_efectividad.exportar',
  // RECET: Importaciones de datos (reporte analítico y fichas por molécula)
  RECET_IMPORTACIONES_VER: 'recet.importaciones.ver',
  RECET_IMPORTACIONES_CARGAR: 'recet.importaciones.cargar',
  // RECET: Fichas de moléculas
  RECET_FICHAS_VER: 'recet.fichas.ver',
  // RECET: Secciones
  SECCIONES_VER: 'recet.secciones.ver',
  SECCIONES_CREAR: 'recet.secciones.crear',
  SECCIONES_EDITAR: 'recet.secciones.editar',
  SECCIONES_ELIMINAR: 'recet.secciones.eliminar',
  // RECET: Media
  MEDIA_VER: 'recet.media.ver',
  MEDIA_SUBIR: 'recet.media.subir',
  // Parametros (compartido; data scopeada por tenant activo)
  PARAMETROS_VER: 'parametros.ver',
  PARAMETROS_CREAR: 'parametros.crear',
  PARAMETROS_MODIFICAR: 'parametros.modificar',
  PARAMETROS_ELIMINAR: 'parametros.eliminar',
  // Notificaciones (compartido; data scopeada por tenant activo)
  PLANTILLAS_VER: 'notificaciones.plantillas.ver',
  PLANTILLAS_EDITAR: 'notificaciones.plantillas.editar',
  PLANTILLAS_ELIMINAR: 'notificaciones.plantillas.eliminar',
  ENVIOS_VER: 'notificaciones.envios.ver',
  ENVIOS_REENVIAR: 'notificaciones.envios.reenviar',
  // RECET: Onboarding
  RECET_ONBOARDING_PASOS_VER: 'recet.onboarding.pasos.ver',
  RECET_ONBOARDING_PASOS_CREAR: 'recet.onboarding.pasos.crear',
  RECET_ONBOARDING_PASOS_EDITAR: 'recet.onboarding.pasos.editar',
  RECET_ONBOARDING_PASOS_ELIMINAR: 'recet.onboarding.pasos.eliminar',
  RECET_ONBOARDING_CONFIGURACION_VER: 'recet.onboarding.configuracion.ver',
  RECET_ONBOARDING_CONFIGURACION_EDITAR: 'recet.onboarding.configuracion.editar',
  RECET_ONBOARDING_RESETEAR: 'recet.onboarding.resetear',
  // ENSUASS: Solicitudes
  ENSUASS_SOLICITUDES_VER: 'ensuass.solicitudes.ver',
  // ENSUASS: Proceso de carga
  ENSUASS_PROCESOCARGA_VER: 'ensuass.procesocarga.ver',
  ENSUASS_PROCESOCARGA_SUBIR: 'ensuass.procesocarga.subir',
  ENSUASS_PROCESOCARGA_CONFIRMAR: 'ensuass.procesocarga.confirmar',
  // Menu (visibilidad del sidebar — desacoplado de los `.ver` de API)
  USUARIOS_MENU: 'seguridad.usuarios.menu',
  ROLES_MENU: 'seguridad.roles.menu',
  PERMISOS_MENU: 'seguridad.permisos.menu',
  SESIONES_MENU: 'seguridad.sesiones.menu',
  TECNOLOGIAS_MENU: 'recet.tecnologias.menu',
  SECCIONES_MENU: 'recet.secciones.menu',
  REFERENCIAS_MENU: 'recet.referencias.menu',
  RECET_IMPORTACIONES_MENU: 'recet.importaciones.menu',
  COSTO_EFECTIVIDAD_MENU: 'recet.costo_efectividad.menu',
  RECET_FICHAS_MENU: 'recet.fichas.menu',
  ORGANIZACIONES_MENU: 'seguridad.organizaciones.menu',
  APLICACIONES_MENU: 'seguridad.aplicaciones.menu',
  SMTP_MENU: 'seguridad.smtp.menu',
  PARAMETROS_MENU: 'parametros.menu',
  RECET_ONBOARDING_MENU: 'recet.onboarding.menu',
  PLANTILLAS_MENU: 'notificaciones.plantillas.menu',
  ENVIOS_MENU: 'notificaciones.envios.menu',
  ENSUASS_SOLICITUDES_MENU: 'ensuass.solicitudes.menu',
} as const;

export type PermisoCode = (typeof Permisos)[keyof typeof Permisos];
